import SmsTestResetPage from "./SmsTestResetPage";

export const DEV_TOOLS = [
  {
    slug: "sms-test-reset",
    title: "SMS Test Reset",
    description:
      "Soft-deletes a contact, its SMS-created leads, and the pending row in communication-service so a QA phone can replay an SMS flow from a clean state.",
    component: SmsTestResetPage,
  },
];

export const devToolPath = (slug) => `/dev/${slug}`;
